
import {Component, Prop, Vue} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import TakipTalebiTaslak from "@/components/TakipTalebiTaslak.vue";
import Emirler from "@/components/Emirler.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {MasrafEntity} from "@/entity/MasrafEntity";
import MasrafForm from "@/components/forms/MasrafForm.vue";
import HacizMasrafForm from "@/components/forms/HacizMasrafForm.vue";
import SatisMasrafForm from "@/components/forms/SatisMasrafForm.vue";
import TebligatMasrafForm from "@/components/forms/TebligatMasrafForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";

@Component({
  components: {
    FormDialog,
    DeleteDialog,
    TebligatMasrafForm,
    SatisMasrafForm,
    HacizMasrafForm, MasrafForm, Emirler, TakipTalebiTaslak, FormWrapper}
})

export default class TebligatMasrafList extends Vue {
  @Prop() tebligatId !: number;
  @Prop({}) items!: Array<MasrafEntity>;
  @Prop() hideCloseButton!: boolean | string;
  tebligatMasraflari: Array<AlacakKalemiEntity> = [];



  get isHideClose() {
    return this.hideCloseButton || this.hideCloseButton === "";
  }

  search: string = "";
  headers = [
    {text: "Tarih", align: "start", sortable: false, value: "masraf_tarihi",},
    {text: "Masraf Çeşidi", align: "start", sortable: false, value: "masraf_cesidi",},
    {text: "Tutar", value: "masraf_tutari", align: "right"},
    {text: "Masraf Türü", value: "gayri_resmi"},
    {text: "Belgeli", value: "belgeli_mi"},
    {text: "İşlemler", value: "actions", sortable: false, align: 'center', width: 100},
  ];


  load() {
    this.$emit('load');
    this.getTebligatMasraflari()
  }

  mounted(){
    console.log(this.tebligatId);
    this.getTebligatMasraflari();
  }


  getTebligatMasraflari(){
    this.$http
        .get('/api/v1/tebligat/' + this.tebligatId +'/masraf')
        .then((response: any) => {
          this.tebligatMasraflari = response.data;
        });
  }

}
